import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-screen min-h-[700px] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/340d44833bca1d3fbbd23777d7890f1b.jpg"
          alt="Premium flooring installation Tampa Bay"
          className="w-full h-full object-cover object-top"
        />
      </div>
      {/* Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-[#0d0d0d]/90 via-[#0d0d0d]/70 to-[#0d0d0d]/40" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0d0d0d]/80 via-transparent to-[#0d0d0d]/30" />

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-8 flex flex-col items-start">
        {/* Location Badge */}
        <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-4 py-2 mb-8">
          <i className="ri-map-pin-line text-[#c9a55a] text-sm" />
          <span className="text-white/90 text-sm font-medium tracking-wide">Serving Tampa Bay &amp; Sarasota</span>
        </div>

        {/* Main Headline */}
        <h1 className="text-4xl md:text-6xl lg:text-7xl font-black text-white leading-tight mb-6 max-w-3xl">
          Flooring, Dustless Demolition &amp;{' '}
          <span className="text-[#c9a55a]">Bathroom Remodeling</span>
        </h1>

        <p className="text-lg md:text-xl text-white/70 font-light mb-8 max-w-xl leading-relaxed">
          Precision installation. Clean demolition. Results that last.
        </p>

        {/* Service Tags */}
        <div className="flex flex-wrap gap-3 mb-10">
          {[
            { icon: 'ri-stack-line', label: 'Hardwood • LVP • Tile' },
            { icon: 'ri-delete-bin-line', label: 'Dustless Floor Removal' },
            { icon: 'ri-building-2-line', label: 'Bathroom Remodeling' },
          ].map((tag) => (
            <div
              key={tag.label}
              className="flex items-center gap-2 bg-[#0d0d0d]/60 backdrop-blur-sm border border-white/20 rounded-full px-4 py-2"
            >
              <i className={`${tag.icon} text-[#c9a55a] text-sm`} />
              <span className="text-white/85 text-sm font-medium whitespace-nowrap">{tag.label}</span>
            </div>
          ))}
        </div>

        {/* CTAs */}
        <div className="flex flex-col sm:flex-row gap-4">
          <Link
            to="/contact"
            className="flex items-center justify-center gap-2 bg-[#c9a55a] hover:bg-[#b8944a] text-[#0d0d0d] font-bold text-base px-8 py-4 rounded-lg transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-calendar-check-line" />
            Get a Free Estimate
          </Link>
          <Link
            to="/flooring-installation"
            className="flex items-center justify-center gap-2 bg-white/10 hover:bg-white/20 backdrop-blur-sm border border-white/30 text-white font-semibold text-base px-8 py-4 rounded-lg transition-all whitespace-nowrap cursor-pointer"
          >
            View All Services
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
        <span className="text-white/40 text-xs tracking-widest uppercase">Scroll</span>
        <i className="ri-arrow-down-line text-white/40 text-lg" />
      </div>
    </section>
  );
}
